// @flow
import * as React from 'react';

import {
  ChoiceFieldGroup,
  ChoiceField,
  useBasicValidators,
} from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { Badge, Base, Block, BlockContent, BlockHeading } from '@gandi/ui';

import { CERT_PROVIDER_INPUT_NAME } from '../../consts';

type LocalChoiceFieldProps = {
  value: string,
  label: string,
  children?: React.Node,
  icon: string,
};

export type ProviderOptionProps = {
  readOnly?: boolean,
  providerAlert?: React.Node,
};
export function ProviderOption({
  readOnly,
  providerAlert,
}: ProviderOptionProps): React.MixedElement {
  const { __ } = useTranslator();
  const { required } = useBasicValidators();

  const items: Array<LocalChoiceFieldProps> = [
    {
      value: 'digicert',
      label: 'Digicert',
      icon: 'digicertIcon',
      children: (
        <Base slot="additional">
          <Base marginBottom="xsmall" marginTop="none" tagName="p">
            {__('Issue your certificate with Digicert.')}
          </Base>
          <Badge intent="success">{__('Better price, better warranty')}</Badge>
        </Base>
      ),
    },
    {
      value: 'sectigo',
      label: 'Sectigo',
      icon: 'security',
    },
  ];

  const choiceGroupProps = {
    legend: __('Which certificate provider do you need?'),
    layout: 'row',
    minWidth: 250,
  };

  return (
    <Block>
      <BlockHeading>{__('Certification authority')}</BlockHeading>
      <BlockContent>
        {providerAlert}
        <ChoiceFieldGroup
          name={CERT_PROVIDER_INPUT_NAME}
          validate={required}
          choiceGroupProps={choiceGroupProps}
        >
          {items.map(props => (
            <ChoiceField
              // eslint-disable-next-line react/prop-types
              key={props.value}
              name={CERT_PROVIDER_INPUT_NAME}
              disabled={readOnly}
              {...props}
            />
          ))}
        </ChoiceFieldGroup>
      </BlockContent>
    </Block>
  );
}
